export enum Mime {
  Png = 'image/png',
  Jpg = 'image/jpeg',
}

// extend as per your needs

Object.freeze(Mime);
